export { TutorGoldenRules, TUTOR_GOLDEN_RULES_TITLE } from "./TutorGoldenRules"
export type { TutorGoldenRulesProps } from "./TutorGoldenRules"
